import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import envelope from '../../assets/img/illustrations/envelope.png';
import { faUndo } from '@fortawesome/free-solid-svg-icons';

const ConfirmMailContent = ({ email, layout, titleTag: TitleTag, alterText }) =>
  <>
    <img className="d-block mx-auto mb-4" src={envelope} alt="sent" width={70} />
    <TitleTag>Por favor revise su correo electrónico!</TitleTag>
    <p>
      Se ha enviado un correo electrónico a <strong>{email}</strong>. {alterText}
    </p>
    <Button tag={Link} color="primary" size="sm" className="mt-3" to={`/authentication/login`}>
      <FontAwesomeIcon icon={faUndo} transform="shrink-4 down-1" className="mr-1" />
      Volver a iniciar sesión
    </Button>
  </>

ConfirmMailContent.propTypes = {
  email: PropTypes.string.isRequired,
  layout: PropTypes.string,
  titleTag: PropTypes.string
};

ConfirmMailContent.defaultProps = { layout: 'basic', titleTag: 'h4', alterText: '' };

export default ConfirmMailContent;